<div class="message-outer">
  <div class="message-middle">
    <div class="message-inner">
      <app-message></app-message>
    </div>
  </div>
</div>
